export enum SessionAuthRoutes {
  Overview = '/overview',
  ChooseAccount = '/choose-account',
}
